export const PARAGRAPH_TRIGGER_SCROLL = 'PARAGRAPH_TRIGGER_SCROLL'
export const KNOWLEDGE_UPDATED = 'KNOWLEDGE_UPDATED'
export const KNOWLEDGE_RELOAD = 'KNOWLEDGE_RELOAD'
